/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { QueryBuilder } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { RootStoreType } from "./index"


/**
 * SmsAddonSubscribedDtoBase
 * auto generated base class for the model SmsAddonSubscribedDtoModel.
 */
export const SmsAddonSubscribedDtoModelBase = ModelBase
  .named('SmsAddonSubscribedDto')
  .props({
    __typename: types.optional(types.literal("SmsAddonSubscribedDto"), "SmsAddonSubscribedDto"),
    /** Correlation id from the originating subscribeSmsAddon mutation */
    requestUuid: types.union(types.undefined, types.string),
    organizationUuid: types.union(types.undefined, types.string),
    subscribedAt: types.union(types.undefined, types.string),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class SmsAddonSubscribedDtoModelSelector extends QueryBuilder {
  get requestUuid() { return this.__attr(`requestUuid`) }
  get organizationUuid() { return this.__attr(`organizationUuid`) }
  get subscribedAt() { return this.__attr(`subscribedAt`) }
}
export function selectFromSmsAddonSubscribedDto() {
  return new SmsAddonSubscribedDtoModelSelector()
}

export const smsAddonSubscribedDtoModelPrimitives = selectFromSmsAddonSubscribedDto().requestUuid.organizationUuid.subscribedAt
